export const TargetTypeAgent = 'AGENT';
export const TargetTypeAutomation = 'AUTOMATION';

export type TargetType = typeof TargetTypeAgent | typeof TargetTypeAutomation;

export interface MessageAutomationConfiguration {
  targetType: TargetType;
}
